<template>
  <div class='pc-nav' :style="{height: nonChrome?'96px':'56px'}">
    <div v-if="nonChrome" class="nonChrome">
      为了保证制作简历的安全性和流畅性，建议您使用Chrome浏览器进行访问
      <i class="iconfont iconx close" @click="close"></i>
    </div>
    <div class='nav-container'>
      <img @click="toIndex" class="logo" alt="超级简历WonderCV LOGO" src="https://photo.wondercv.com/white-logo.png">

      <div class='middle'>
        {{cvName}}
      </div>


      <div class="right-part">
        <div>
          <appIcon/>
          <div class="line"></div>
          <!-- 未登录 -->
          <div v-if="!isLogin">
            <button @click='toLogin' class="margin-left">登录</button>
            <button class="action" @click='toReg'>注册</button>
          </div>
          <!-- 登陆 -->
          <div v-else>
            <personIcon/>
          </div>
           <!-- -->
          <!--a href="/account/users/buy_member" v-if="true || isDouble" style="color: #50a4ff;font-size: 14px;">✨ 2020抗疫福利，组队升级双倍会员</a>
          <div class="vip" v-show="false && !isDouble && !personInfo.is_membership" @click="showAlert">
            <img src="https://files.wondercv.com/vip.png" alt="">
            <p class="text-overflow">分享免费获得超级会员，立即升级</p>
            <<p class="text-overflow">✨ 2020开年福利，组队升级双倍会员</p> >
          </div-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import Cookies from 'js-cookie'
  window.Cookies = Cookies;
  import api from '@/api'
  import moment from 'moment';
  import personIcon from '@/components/base/personIcon'
  import appIcon from '@/components/base/phone'
  import { getSignature, getUserInfo, dealSignatrue, routerTo, updateJWT } from '~/assets/js/util'
  const personalMenu = [
    {label: '账号设置', icon: 'https://files.wondercv.com/setting-icon.png', url: '/account/users'},
    {label: '超级会员', icon: 'https://files.wondercv.com/membership-icon.png', url: '/account/users/buy_member'},
    {label: '我的订单', icon: 'https://files.wondercv.com/my-order-icon.png', url: '/account/users?index=3'},
    {label: '问题反馈', icon: 'https://files.wondercv.com/feedback-icon.png', url: '/zh-CN/feedbacks/new'},
    {label: '退出登录', icon: 'https://files.wondercv.com/signout-icon.png', url: '/zh-CN/signin?type=login'}
  ];
  export default {
    components: {
      personIcon,
      appIcon
    },
    props: {
      currHeader: {
        type: Number,
        default: null
      },
      cvToken: {
        type: String,
        default: ''
      },
      cvName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        moment,
        navList: [
          {label: '简历模板', url: '/jianlimoban/'},
          {label: '简历修改', url: '/service/'},
          {label: '求职信', url: '/emails/my'},
          {label: '热门职位', url: '/jobs/'},
          {label: '简历攻略', url: '/blog/'},
          // {label: '加入我们', url: '/welcome/join_us', img: 'https://files.wondercv.com/hot-icon.png'}
        ],
        personalMenu,
        useByPhone: 'app',
        usePhone: false,
        personalMenuStatus: false
      }
    },
    computed: {
      ...mapState('me', ['isLogin', 'personInfo', 'isMembership', 'isUser']),
      ...mapState('app', ['navbarAction', 'isDouble']),
      ...mapState('global', ['nonChrome'])
    },
    watch: {
      isLogin: {
        handler(val) {
          if (val) {
            this.navList[0] = {label: '我的简历', url: '/cvs'}
            this.navList[2] = {label: '求职邮箱', url: '/emails/my'}
          } else {
            this.navList[0] = {label: '简历模板', url: '/jianlimoban/'}
            this.navList[2] = {label: '求职信', url: '/emails/my'}
          }
          this.$forceUpdate()
        },
        immediate: true
      },
      personInfo: {
        deep: true,
        immediate: true,
        handler(personInfo) {
          let arr = [...personalMenu];
          // if (personInfo.admin) {
          //   let obj = {label: '管理入口', icon: 'https://files.wondercv.com/pc/navbar/manage.png', url: 'https://admin.wondercv.com'};
          //   arr.splice(arr.length - 1, 0, obj);
          // }
          // if (personInfo.group_name) {
          //   let obj = {label: '机构入口', icon: 'https://files.wondercv.com/pc/navbar/framework.png', url: value.group_url};
          //   arr.splice(arr.length - 1, 0, obj);
          // }
          if (personInfo.mentor) {
            let obj = {label: '导师入口', icon: 'https://files.wondercv.com/pc/navbar/mentor.png', url: '/mentor/tasks'};
            arr.splice(arr.length - 1, 0, obj);
          }
          this.personalMenu = arr;
        }
      }
    },
    created() {
      // this.$store.dispatch('me/personMenu')
    },
    methods: {
      ...mapMutations("global", ['setNonChrome']),
      toRoot () {
      },
      toCv (nav) {
        routerTo(nav.url)
      },
      toEmail () {
      },
      toJob () {
      },
      toService () {
      },
      toIndex() {
        routerTo('/')
      },
      toLogin () {
        routerTo('/auth-signin/?type=login')
      },
      toReg () {
        routerTo('/auth-signin/?type=login')
      },
      changeUsePhone (type) {
        this.useByPhone = type
      },
      show (state) {
        this[state] = true
      },
      hide (state) {
        this[state] = false
      },
      // showAlert() {
      //   let alertData = {
      //     show: true,
      //     type: 'upVip'
      //   }
      //   this.$store.dispatch('app/setAlertData', alertData)
      // },
      close() {
        this.setNonChrome()
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~/assets/css/variable';
  .close {
    color: #FF6644;
    position: absolute;
    top: 0px;
    right: 32px;
    font-size: 24px;
    cursor: pointer;
  }
  .nonChrome{
    width: 100%;
    height: 40px;
    background-color:#FFF6F4;
    color: #FF6644;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    position: relative;
  }
  .pc-nav {
    position: fixed;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 56px;
    z-index: 9;
    background-color: #202329;
    box-sizing: border-box;

    .nav-container {
      height: 56px;
      width: 1196px;
      margin: auto;
      position: relative;

      .logo {
        vertical-align: middle;
        height: 32px;
        position: absolute;
        left: 0;
        top: 12px;
        z-index: 3;
        cursor: pointer;
      }

      .middle {
        color: #fff;
        text-align: center;
        line-height: 56px;
      }

      .right-part {
        flex:none;
        // min-width: 230px;
        height: 100%;
        z-index: 3;
        position: absolute;
        right: 0;
        top: 0;
        &>div {
          display: flex;
          align-items: center;
          height: 100%;
          justify-content: flex-end;
        }
        .line {
          width: 1px;
          height: 16px;
          background: #36393E;
          margin: 0 16px;
        }
        button {
          width: 76px;
          height: 30px;
          border: 1px solid #797B7E;
          color: #fff;
          cursor: pointer;
          margin-left: 16px;
          border-radius: 15px;
          font-size: 14px;
          background: #202329;
          &.action{
            background: #FF6644;
            border: 1px solid #FF6644;
          }
          &:hover {
            border: 1px solid #fff;
          }
          &.action:hover{
            background: #FF856A;
            border: 1px solid #FF856A;
          }
          &.margin-left {
            margin-left: 0;
          }
        }
        .app {
          height: 100%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          &>img {
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-top: 2px;
            margin-right: -1px;
            margin-left: 1px;
          }
          &:hover .code {
            display: block;
          }
          .code {
            display: none;
            width: 238px;
            height: 305px;
            background: #fff;
            border: 1px solid #DEDFE1;
            position: absolute;
            bottom: -305px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            color: #404040;
            border-radius: 4px;
            box-shadow: 0 6px 12px rgba(0,0,0,0.175);
            .title {
              line-height: 20px;
              font-size: 14px;
              text-align: center;
              margin-top: 17px;
            }
            img {
              width: 160px;
              height: 160px;
              margin: 4px auto 0;
            }
            .btn {
              button {
                display: block;
                background: #fff;
                margin: auto;
                width: 160px;
                height: 30px;
                border: 1px solid #ff4f4c;
                text-align: center;
                line-height: 27px;
                border-radius: 2px;
                color: #ff4f4c;
                margin: auto;
                margin-top: 12px;
                &.action, &:hover {
                  color: #fff;
                  background: #ff4f4c;
                }
              }
            }
          }
        }
        .user {
          height: 100%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: -3px;
          cursor: pointer;
          .user-pic {
            width: 28px;
            height: 28px;
            border-radius: 14px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          &>img {
            width: 25px;
            height: 25px;
            margin-top: 1px;
            &.v {
              width: 36px;
              height: 36px;
              margin-right: -9px;
              margin-left: -2px;
            }
          }
          &:hover .personal-menu {
            display: block;
          }
          .personal-menu {
            position: absolute;
            right: -15px;
            bottom: 0;
            transform: translateY(100%);
            width: 198px;
            background-color: $color-light;
            padding: 5px 0;
            margin: 0px 0;
            border: 1px solid rgba(0, 0, 0, 0.15);
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
            border-radius: 4px;
            display: none;
            .menu-title {
              // min-height: 60px;
              // max-width: 180px;
              // width: 80%;
              margin: auto;
              text-align: center;
              position: relative;
              overflow: hidden;
              cursor: auto;
              padding-bottom: 8px;
              margin-bottom: 2px;
              &::after {
                content: "";
                display: block;
                width: 100%;
                height: 1px;
                background: #F2F2F2;
                position: absolute;
                left: 8px;
                bottom: 0;
              }
              .t {
                color: #ff4f4c;
                padding-top: 14px;
                padding-bottom: 8px;
                line-height: 20px;
              }
              p {
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .member-btn {
                width: 44px;
                height: 24px;
                background: #ff4f4c;
                font-size: 14px;
                color: #fff;
                display: block;
                border-radius: 2px;
                margin-left: 25px;
              }
            }
            .menu-item {
              display: flex;
              align-items: center;
              height: 52px;
              padding: 0 20px;
              cursor: pointer;
              &:hover {
                background-color: #f5f5f5;
              }
              img {
                max-width: 14px;
                max-height: 14px;
                margin: 0 20px;
              }
            }
          }
        }
        .vip {
          display: flex;
          align-items: center;
          color: #50a4ff;
          cursor: pointer;
          margin-right: 0px;
          img {
            width: 17px;
            height: 17px;
            margin-right: 2px;
          }
        }
        @media screen and (max-width: 1300px) {
          .vip p {
            // width: 140px;
          }
        }
      }
    }
  }
</style>
